import React from 'react';
import Modal from 'react-bootstrap/Modal';
import InputField from '../Reusable/InputField';
import withTranslations from '../../utils/HighOrderComponent';
import ButtonSave from '../Reusable/ButtonSave';
import { handleErrorMessage } from '../../utils';
import ErrorHandler from '../Reusable/ErrorHandler';

class ModalForAddOrUpdatePlace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placeName: props.place?.name || '',

      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;
    const { Errors } = this.props.t;
    const { placeName } = this.state;
    let errors = {};

    if (!placeName) {
      errors['placeName'] = Errors.placeName;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const placeForUpdate = {
      ...this.props.place,
      name: this.state.placeName,
    };

    placeForUpdate?.id
      ? this.props.updatePlace(placeForUpdate)
      : this.props.createPlace(placeForUpdate);
  };

  render() {
    const { error, deleteError, t } = this.props || {},
      { Placeholders, title } = t || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={this.props.secondModal && 'secondModal'}
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <ErrorHandler error={error} deleteError={deleteError} />
            <h5 className="title mb-4">{title}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="form-group">
                  <InputField
                    name="placeName"
                    placeholder={Placeholders.placeName}
                    onChange={this.onChange}
                    value={this.state.placeName}
                    error={handleErrorMessage(
                      error,
                      'placeName',
                      this.state.errors.placeName
                    )}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForAddOrUpdatePlace,
  'ModalForAddOrUpdatePlace'
);
